import React, { useContext, useEffect, useState } from 'react';
import Configurator from '../components/configurator/Configurator';
import SlidingFrontsConfig from '../components/configurationOptions/SlidingFrontsConfig';
import HingedFrontsConfig from '../components/configurationOptions/HingedFrontsConfig';
import ProgressBar from '../components/ProgressBar';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import { ConfiguratorModeContext } from '../contexts/ConfiguratorModeContext';
import { PriceContext } from '../contexts/PriceContext';
import calculatePrice from '../helpers/calculatePrice';

const WardrobeFrontsConfiguration = () => {
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { setCurrentConfiguratorMode } = useContext(ConfiguratorModeContext);
  const wardrobe = wardrobesConfigs[activeWardrobe];
  const { setPrice } = useContext(PriceContext);

  const [isSliding, setIsSliding] = useState(true);

  useEffect(() => {
    if (!wardrobe.is_hinged !== isSliding) {
      setIsSliding(prev => {
        return !wardrobe.is_hinged;
      });
    }
  }, [setCurrentConfiguratorMode, isSliding, wardrobe.is_hinged]);

  return (
    <Configurator>
      <ProgressBar link="/wardrobe-body-configuration" activeLvl={1} />
      {isSliding ? (
        <SlidingFrontsConfig
          setPrice={() => setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]))}
        />
      ) : (
        <HingedFrontsConfig
          setPrice={() => setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]))}
        />
      )}
    </Configurator>
  );
};

export default WardrobeFrontsConfiguration;
